function loadScript(src) {
	return new Promise((resolve, reject) => {
		if (document.querySelector(`script[src="${src}"]`)) {
			return resolve();
		}
		const el = document.createElement("script");
		el.src = src;
		el.async = true;
		el.onload = resolve;
		el.onerror = reject;
		document.head.appendChild(el);
	});
}

async function ensureLibs() {
	const tasks = [];

	if (!window.html2canvas) {
		tasks.push(
			loadScript(
				"https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js"
			)
		);
	}

	// ✅ On vérifie si le constructeur jsPDF existe vraiment
	const hasJsPDF =
		(window.jspdf && window.jspdf.jsPDF) ||
		(window.jsPDF &&
			(window.jsPDF.jsPDF || typeof window.jsPDF === "function"));

	if (!hasJsPDF) {
		tasks.push(
			loadScript(
				"https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js"
			)
		);
	}

	await Promise.all(tasks);
}

function imageUrlToPngDataUrl(url) {
	return new Promise((resolve) => {
		if (!url) return resolve(null);

		const img = new Image();
		img.crossOrigin = "anonymous";

		img.onload = () => {
			try {
				const canvas = document.createElement("canvas");
				canvas.width = img.naturalWidth || img.width;
				canvas.height = img.naturalHeight || img.height;

				const ctx = canvas.getContext("2d");
				ctx.fillStyle = "#ffffff";
				ctx.fillRect(0, 0, canvas.width, canvas.height);
				ctx.drawImage(img, 0, 0);

				const dataUrl = canvas.toDataURL("image/png");
				resolve(dataUrl);
			} catch (e) {
				console.error("Logo PNG conversion failed", e);
				resolve(null);
			}
		};

		img.onerror = () => resolve(null);
		img.src = url;
	});
}

function getLogoSize(dataUrl, maxWidth, maxHeight) {
	return new Promise((resolve) => {
		if (!dataUrl) return resolve(null);

		const img = new Image();

		img.onload = () => {
			let width = img.width;
			let height = img.height;
			const ratio = Math.min(maxWidth / width, maxHeight / height);

			resolve({
				width: width * ratio,
				height: height * ratio,
			});
		};

		img.src = dataUrl;
	});
}

function renderHeaderFooter(doc, page, cfg) {
	const {
		primaryLogoPng,
		secondaryLogoPng,
		primarySize,
		secondarySize,
		pageWidth,
		pageHeight,
		pageTitle,
		margin,
	} = cfg;

	const headerCenterY = 35;

	if (primaryLogoPng && primarySize) {
		const y = headerCenterY - primarySize.height / 2;
		doc.addImage(
			primaryLogoPng,
			"PNG",
			margin,
			y,
			primarySize.width,
			primarySize.height
		);
	}

	if (secondaryLogoPng && secondarySize) {
		const y = headerCenterY - secondarySize.height / 2;
		const x = pageWidth - margin - secondarySize.width;
		doc.addImage(
			secondaryLogoPng,
			"PNG",
			x,
			y,
			secondarySize.width,
			secondarySize.height
		);
	}

	if (pageTitle) {
		doc.setFontSize(11);
		doc.setTextColor(40);

		const leftLimit = margin + (primarySize ? primarySize.width + 15 : 0);
		const rightLimit =
			pageWidth - margin - (secondarySize ? secondarySize.width + 15 : 0);
		const maxWidth = rightLimit - leftLimit;

		doc.text(pageTitle, pageWidth / 2, headerCenterY + 5, {
			align: "center",
			maxWidth,
		});
	}

	const url = window.location.href;
	doc.setFontSize(9);
	doc.setTextColor(60);
	doc.text(url, margin, pageHeight - 18);
	doc.text(`Page ${page}`, pageWidth - margin, pageHeight - 18, {
		align: "right",
	});
}

document.addEventListener("DOMContentLoaded", () => {
	const blocks = document.querySelectorAll(".wp-block-brblocks-section-to-pdf");
	if (!blocks.length) return;

	const primaryLogoUrl =
		document.querySelector("#itu-primary-logo img")?.src || null;
	const secondaryLogoUrl =
		document.querySelector("#itu-secondary-logo img")?.src || null;

	const titleEl = document.querySelector("#mainContent h1, .entry-title, h1");
	const pageTitle = titleEl ? titleEl.textContent.trim() : document.title;

	blocks.forEach((block) => {
		const button = block.querySelector(".br-section-to-pdf-button");
		const content = block.querySelector(".br-section-to-pdf-inner") ?? block;
		const fileName = block.dataset.filename || "section.pdf";

		if (!button || !content) return;

		// ✅ SÉCURISATION DU BINDING
		if (button.dataset.pdfBound) return;
		button.dataset.pdfBound = "1";

		button.addEventListener("click", async () => {
			try {
				await ensureLibs();

				await new Promise((resolve, reject) => {
					let tries = 0;
					const t = setInterval(() => {
						if (window.jspdf && window.jspdf.jsPDF) {
							clearInterval(t);
							resolve();
						}
						if (++tries > 200) {
							// ~2 secondes
							clearInterval(t);
							reject("jsPDF load timeout");
						}
					}, 10);
				});

				const jsPDFCtor =
					(window.jspdf && window.jspdf.jsPDF) ||
					(window.jsPDF && window.jsPDF.jsPDF) ||
					(typeof window.jsPDF === "function" ? window.jsPDF : null);

				if (!jsPDFCtor) {
					console.error("jsPDF not available", {
						jspdf: window.jspdf,
						jsPDF: window.jsPDF,
					});
					return;
				}

				const [primaryLogoPng, secondaryLogoPng] = await Promise.all([
					imageUrlToPngDataUrl(primaryLogoUrl),
					imageUrlToPngDataUrl(secondaryLogoUrl),
				]);

				const logoMaxWidth = 80;
				const logoMaxHeight = 40;

				const [primarySize, secondarySize] = await Promise.all([
					primaryLogoPng
						? getLogoSize(primaryLogoPng, logoMaxWidth, logoMaxHeight)
						: null,
					secondaryLogoPng
						? getLogoSize(secondaryLogoPng, logoMaxWidth, logoMaxHeight)
						: null,
				]);

				const accordionStates = [];
				content
					.querySelectorAll(".wp-block-brblocks-accordion")
					.forEach((acc) => {
						const panel = acc.querySelector(".accordion-content");
						if (!panel) return;

						accordionStates.push({
							panel,
							parent: acc,
							prevStyle: panel.getAttribute("style"),
							hadHidden: panel.hasAttribute("hidden"),
							hadOpen: acc.classList.contains("is-open"),
						});

						acc.classList.add("is-open");
						panel.style.display = "block";
						panel.style.maxHeight = "none";
						panel.style.overflow = "visible";
						panel.removeAttribute("hidden");
					});

				const tabContainers = [];
				content
					.querySelectorAll(".tab-contents, .brblocks-tabs-content-wrapper")
					.forEach((wrap) => {
						tabContainers.push({
							el: wrap,
							prevStyle: wrap.getAttribute("style"),
						});

						wrap.style.height = "auto";
						wrap.style.maxHeight = "none";
						wrap.style.overflow = "visible";
						wrap.style.display = "block";
					});

				const tabPanelsState = [];
				content
					.querySelectorAll(".tab-content, .brblocks-tabs-panel")
					.forEach((panel) => {
						tabPanelsState.push({
							el: panel,
							prevClass: panel.className,
							prevStyle: panel.getAttribute("style"),
							prevHidden: panel.getAttribute("aria-hidden"),
						});

						panel.classList.add("active");
						panel.style.display = "block";
						panel.style.maxHeight = "none";
						panel.style.overflow = "visible";
						panel.setAttribute("aria-hidden", "false");
					});

				await new Promise(requestAnimationFrame);

				const linkPositions = [];

// ===== MEASURE REAL CONTENT =====
const contentRect = content.getBoundingClientRect();

console.log(
	"CONTENT SIZE →",
	contentRect.width,
	"x",
	contentRect.height
);

if (!contentRect.height || contentRect.height < 5) {
	console.error("Content height = 0 → abort PDF");
	return;
}

// collect link positions
content.querySelectorAll("a[href]").forEach((a) => {
	const rect = a.getBoundingClientRect();
	if (rect.width === 0 || rect.height === 0) return;

	linkPositions.push({
		href: a.href,
		topDom: rect.top - contentRect.top,
		leftDom: rect.left - contentRect.left,
		widthDom: rect.width,
		heightDom: rect.height,
	});
});

				// ===== CAPTURE =====
				const canvas = await window.html2canvas(content, {
					scale: 2,
					useCORS: true,
					allowTaint: true,
					backgroundColor: "#ffffff",
					foreignObjectRendering: false,
				});

				// ===== CLEAN =====

				const domToCanvasScale = canvas.width / contentRect.width;

				accordionStates.forEach((state) => {
					const { panel, parent, prevStyle, hadHidden, hadOpen } = state;

					if (prevStyle !== null) {
						panel.setAttribute("style", prevStyle);
					} else {
						panel.removeAttribute("style");
					}

					if (hadHidden) {
						panel.setAttribute("hidden", "");
					} else {
						panel.removeAttribute("hidden");
					}

					if (!hadOpen) {
						parent.classList.remove("is-open");
					}
				});

				tabContainers.forEach((s) => {
					if (s.prevStyle !== null) {
						s.el.setAttribute("style", s.prevStyle);
					} else {
						s.el.removeAttribute("style");
					}
				});

				tabPanelsState.forEach((state) => {
					const { el, prevClass, prevStyle, prevHidden } = state;

					el.className = prevClass;

					if (prevStyle !== null) {
						el.setAttribute("style", prevStyle);
					} else {
						el.removeAttribute("style");
					}

					if (prevHidden !== null) {
						el.setAttribute("aria-hidden", prevHidden);
					} else {
						el.removeAttribute("aria-hidden");
					}
				});

				const pdf = new jsPDFCtor("p", "pt", "a4");
				const pageWidth = pdf.internal.pageSize.getWidth();
				const pageHeight = pdf.internal.pageSize.getHeight();

				const margin = 40;
				const headerHeight = 20;
				const footerHeight = 20;
				const usableHeight =
					pageHeight - margin * 2 - headerHeight - footerHeight;

				const scaleFactor = 0.85;
				const imgWidth = (pageWidth - margin * 2) * scaleFactor;

				const sliceCanvas = document.createElement("canvas");
				const sliceCtx = sliceCanvas.getContext("2d");
				sliceCanvas.width = canvas.width;

				let sliceHeightSrc = Math.floor(
					canvas.width * (usableHeight / imgWidth)
				);
				if (sliceHeightSrc < 50) sliceHeightSrc = 50;

				let ySource = 0;
				let pageNumber = 1;

				while (ySource < canvas.height) {
					const sliceHeight = Math.min(sliceHeightSrc, canvas.height - ySource);
					if (sliceHeight <= 0) break;

					sliceCanvas.height = sliceHeight;
					sliceCtx.clearRect(0, 0, sliceCanvas.width, sliceCanvas.height);
					sliceCtx.drawImage(
						canvas,
						0,
						ySource,
						canvas.width,
						sliceHeight,
						0,
						0,
						canvas.width,
						sliceHeight
					);

					const pageImg = sliceCanvas.toDataURL("image/png");
					const pageImgHeight = (sliceHeight * imgWidth) / canvas.width;

					if (pageNumber > 1) {
						pdf.addPage();
					}

					renderHeaderFooter(pdf, pageNumber, {
						primaryLogoPng,
						secondaryLogoPng,
						primarySize,
						secondarySize,
						pageWidth,
						pageHeight,
						pageTitle,
						margin,
					});

					const imgY = headerHeight + margin;

					pdf.addImage(pageImg, "PNG", margin, imgY, imgWidth, pageImgHeight);

					const imageScale = imgWidth / canvas.width;
					const ySliceStartCanvas = ySource;
					const ySliceEndCanvas = ySource + sliceHeight;

					linkPositions.forEach((link) => {
						const topCanvas = link.topDom * domToCanvasScale;
						const heightCanvas = link.heightDom * domToCanvasScale;
						const bottomCanvas = topCanvas + heightCanvas;

						if (
							bottomCanvas < ySliceStartCanvas ||
							topCanvas > ySliceEndCanvas
						) {
							return;
						}

						const leftCanvas = link.leftDom * domToCanvasScale;
						const widthCanvas = link.widthDom * domToCanvasScale;

						const relTopInSlice = topCanvas - ySliceStartCanvas;

						const pdfX = margin + leftCanvas * imageScale;
						const pdfY = imgY + relTopInSlice * imageScale;
						const pdfW = widthCanvas * imageScale;
						const pdfH = heightCanvas * imageScale;

						if (typeof pdf.link === "function") {
							pdf.link(pdfX, pdfY, pdfW, pdfH, {
								url: link.href,
							});
						}
					});

					ySource += sliceHeight;
					pageNumber++;
				}

				pdf.save(fileName);
			} catch (e) {
				console.error("Error generating PDF:", e);
			}
		});
	});
});
